export default {
  appName: '经贸活动云',
  loading: false,
  token: null,
  user: null,
  errorVisible: false,
  error: null,
  menuVisible: false,
  menu: [
    {
      id: 1,
      name: 'meeting',
      title: '活动管理',
      icon: 'pages',
      children: [
        { id: 101, title: '创建活动', name: 'meeting-create' },
        { id: 102, title: '活动列表', name: 'meeting-list' }
      ]
    },
    {
      id: 2,
      name: 'message',
      title: '通知管理',
      icon: 'setting',
      children: [
        { id: 201, name: 'email-list', title: '邮件列表' },
        { id: 202, name: 'text-list', title: '短信列表' }
      ]
    },
    {
      id: 3,
      name: 'statistics',
      title: '统计分析',
      icon: 'iso-stats',
      children: [
        { id: 301, name: 'statistics-meeting-list', title: '活动分析' }
      ]
    },
    {
      id: 4,
      name: 'setting',
      title: '账户管理',
      icon: 'setting',
      parentAdminUserId: 1,
      children: [
        { id: 402, name: 'user-list', title: '子账户管理', parentAdminUserId: 1 },
        { id: 403, name: 'org-list', title: '机构管理', parentAdminUserId: 1 }
      ]
    },
    {
      id: 5,
      name: 'attendee',
      title: '参会人管理',
      icon: 'setting',
      children: [
        { id: 501, name: 'attendee-list', title: '参会人列表' }
      ]
    },
    {
      id: 6,
      name: 'applyRequest',
      title: '试用申请',
      icon: 'setting',
      parentAdminUserId: 1,
      children: [
        { id: 601, name: 'apply-request-list', title: '申请列表', parentAdminUserId: 1 }
      ]
    }
  ],
  pageTitle: ''
}



// WEBPACK FOOTER //
// ./src/store/state.js